import { ChannelsSettingsSubMenuRoutes } from 'modules/Channels/channelsPagesConfig';
import { Navigate } from 'react-router-dom';
import { lazyLoad } from 'utils/loadable';

const ChannelsPage = lazyLoad(() =>
  import(/*  webpackChunkName: 'ChannelsPage', webpackPrefetch: true */ '.'),
);

const WhatsappTemplatesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WhatsappTemplatesPage', webpackPrefetch: true */ './components/Whatsapp/WhatsappTemplates'
  ),
);

const ManageWhatsappTemplatesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ManageWhatsappTemplatesPage', webpackPrefetch: true */ './components/Whatsapp/ManageWhatsappTemplates'
  ),
);

const WhatsappLogsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WhatsappLogsPage', webpackPrefetch: true */ './components/Whatsapp/WhatsappLogs'
  ),
);

const EmailTemplatesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'EmailTemplatesPage', webpackPrefetch: true */ './components/Email/EmailTemplates'
  ),
);

const ManageEmailTemplatePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ManageEmailTemplatePage', webpackPrefetch: true */ './components/Email/ManageEmailTemplate'
  ),
);

const EmailLogsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'EmailLogsPage', webpackPrefetch: true */ './components/Email/EmailLogs'
  ),
);

const WhatsappEventMappingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WhatsappEventMappingPage', webpackPrefetch: true */ './components/Whatsapp/WhatsappEventMapping'
  ),
);

const EmailEventMappingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'EmailEventMappingPage', webpackPrefetch: true */ './components/Email/EmailEventMapping'
  ),
);

export const channelsMenuRoutes = allowAdminRoutes => [
  ...(allowAdminRoutes
    ? [
        {
          component: WhatsappTemplatesPage,
          title: 'Whatsapp Templates',
          path: ChannelsSettingsSubMenuRoutes.WHATSAPP_TEMPLATES,
        },
        {
          component: ManageWhatsappTemplatesPage,
          title: 'Manage Whatsapp Templates',
          path: ChannelsSettingsSubMenuRoutes.MANAGE_WHATSAPP_TEMPLATES,
        },
        {
          component: WhatsappLogsPage,
          title: 'Whatsapp Logs',
          path: ChannelsSettingsSubMenuRoutes.WHATSAPP_LOGS,
        },
        {
          component: EmailTemplatesPage,
          title: 'Email Templates',
          path: ChannelsSettingsSubMenuRoutes.EMAIL_TEMPLATES,
        },
        {
          component: ManageEmailTemplatePage,
          title: 'Manage Email Template',
          path: ChannelsSettingsSubMenuRoutes.MANAGE_EMAIL_TEMPLATE,
        },
        {
          component: EmailLogsPage,
          title: 'Email Logs',
          path: ChannelsSettingsSubMenuRoutes.EMAIL_LOGS,
        },
        {
          component: WhatsappEventMappingPage,
          title: 'Whatsapp Event Mapping',
          path: ChannelsSettingsSubMenuRoutes.WHATSAPP_EVENT_MAPPING,
        },
        {
          component: EmailEventMappingPage,
          title: 'Email Event Mapping',
          path: ChannelsSettingsSubMenuRoutes.EMAIL_EVENT_MAPPING,
        },
      ]
    : []),
];

// routes declaration
export const channelsRoutes = [
  {
    component: Navigate,
    path: '/channels',

    replace: true,
    to: '/channels' + ChannelsSettingsSubMenuRoutes.DEFAULT,
    toAdmin: '/channels' + ChannelsSettingsSubMenuRoutes.DEFAULT,
    needsAuth: true,
  },
  {
    component: ChannelsPage,
    title: 'Channels',
    path: '/channels/*',
    needsAuth: true,
  },
];
